import React from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  Form as BForm,
} from "@themesberg/react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import Toggle from '../../../../components/Toggle/Toggle.jsx'
import { getBankingDetailsHeaders, getBankingDetailsInitialValues, getBankingDetailsValidationSchema } from "../helpers.js";

const AddEditModal = ({
  type,
  data,
  show,
  setShow,
  createUpdate,
  bankType,
}) => {
  const headers = getBankingDetailsHeaders(bankType);
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{type} Details </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={getBankingDetailsInitialValues(bankType, data)}
            validationSchema={getBankingDetailsValidationSchema(bankType)}
            onSubmit={(values) => {
              for (let k in values) {
                if (typeof values[k] === "string") values[k] = values[k].trim();
              }
              if (type === "Edit") values.bankDetailsId = data?.bankDetailsId;
              values.bankType = bankType;
              createUpdate(values);
            }}
            
          >
            {({
              values,
              errors,
              handleSubmit,
              handleBlur,
              handleChange,
              setFieldValue,
              isValid,
              dirty,
              initialValues,
            }) => {
              return (
                <Form>
                  {headers
                   .filter((h) => h.isShowModal) 
                    .slice(0, headers.length - 1)
                    .map((h) => (
                      <Row className="mt-3" key={h.value}>
                        <Col className="d-flex align-items-center">
                          <Col>
                            <BForm.Label>
                              {h.label}
                              {h.isRequired &&  <span className="text-danger">*</span>}
                            </BForm.Label>
                          </Col>

                          <Col xs={9}>
                            {
                              h.label.toLowerCase() === "status" && (
                                <Toggle
                                  checked={values.status}
                                  onChange={(e) => {
                                    setFieldValue("status", e.target.checked);
                                  }}
                                  justify="left"
                                />
                              )
                            }
                            {
                              h.label.toLowerCase() === "account type" && (
                                <BForm.Select
                                  name={h.value}
                                  value={values[h.value]}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <option value="SAV">SAV</option>
                                  <option value="CHK">Cheque(CHK)</option>
                                </BForm.Select>
                              )
                            }
                            {
                              !["status", "account type"].includes(
                                h.label.toLowerCase()
                              ) && (
                                (
                                  <BForm.Control
                                    type="text"
                                    name={h.value}
                                    placeholder={h.label}
                                    value={values[h.value]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                )
                              )
                            }

                            <ErrorMessage
                              component="div"
                              name={h.value}
                              className="text-danger"
                            />
                          </Col>
                        </Col>
                      </Row>
                    ))}

                  <div className="mt-4 d-flex justify-content-between align-items-center">
                    <Button
                      className="btn-danger"
                      onClick={() => setShow(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn-primary ml-2"
                      disabled={!isValid || !dirty}
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddEditModal;
